import { ResCurrentUser } from '../type/user';
import { BaseResponse, notStandardAjax } from './fetch';

/**
 * 验证登录信息
 * @param {string} token 集团登录返回的token
 * @returns {object} 用户信息
 */
export async function verify(token: string): Promise<BaseResponse<ResCurrentUser>> {
  const { data } = await notStandardAjax.get<BaseResponse<ResCurrentUser>>('/haichuan/api/sso/verify', { token });
  return data;
}

/**
 * 退出登录
 * @returns {object} 状态信息
 */
export async function getLogoutUrl(): Promise<BaseResponse<string>> {
  const { data } = await notStandardAjax.get<BaseResponse<string>>('/haichuan/api/logout', {});
  return data;
}

/**
 * 获取json数据
 */
export async function getNoticeJSON(url: string) {
  const res = await fetch(url);
  const data = await res.json();
  console.log(data, 'res');
  return data;
}
